import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';
import SequenceDiagram from 'src/components/SequenceDiagram';
import Checkbox from 'src/components/Checkbox';
import RadioGroup from 'src/components/RadioGroup';
import Columns from 'src/components/Columns';
import './TxnAuthkeyPage.scss';

const actors = [
    {
        name: "Customer's Browser"
    },
    {
        name: "Merchant"
    },
    {
        name: "BPOINT"
    }
];

function TxnAuthkeyPage() {

    const [paymentMethod, setPaymentMethod] = useState('2party-authkey');
    const [authentication, setAuthentication] = useState(false);
    const [surchargeRates, setSurchargeRates] = useState(false);
    const [surchargeConfirmation, setSurchargeConfirmation] = useState(false);
    const [fraudScreening, setFraudScreening] = useState(false);
    const [statementDescriptor, setStatementDescriptor] = useState(false);
    const [withToken, setWithToken] = useState(false);

    const is2PartyOnly = paymentMethod === '2party';

    let paymentMethodInteraction;
    switch (paymentMethod) {
        case '2party-authkey':
            paymentMethodInteraction = [
                {
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + '#operation/TxnAuthkey_AttachPaymentMethod'}>Attach {withToken ? 'token' : 'card'}</Link>,
                    includeReturn: true,
                },
            ];
            break;
        case 'javascriptSimple':
            paymentMethodInteraction = !withToken
                ? [
                    {
                        start: 0,
                        end: 1,
                        text: 'Authkey',
                        backwards: true,
                    },
                    {
                        start: 0,
                        end: 2,
                        text: <Link to={routes.api.txn.authkey.javascriptSimple}>Setup payment method form</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 2,
                        text: 'User enters and submits card details',
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Payment method complete'
                    }
                ]
                : [
                    {
                        start: 1,
                        end: 2,
                        text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachPaymentMethod"}>Attach token</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Authkey',
                        backwards: true,
                    },
                    {
                        start: 0,
                        end: 2,
                        text: <Link to={routes.api.txn.authkey.javascriptSimple}>Setup payment method form</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 2,
                        text: 'User enters and submits card details',
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Payment method complete'
                    }
                ];
            break;
        case 'javascriptAdvanced':
            paymentMethodInteraction = !withToken ? [
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.javascriptAdvanced + '#Specification'}>Attach card</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            : [
                {
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachPaymentMethod"}>Attach token</Link>,
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.javascriptAdvanced + '#Specification'}>Retrieve token details</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.javascriptAdvanced + '#Specification'}>Update card expiry/cvn</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            break;
        case 'iframeFields':
            paymentMethodInteraction = !withToken ? [
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.iframeFields}>Create payment method form</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.iframeFields}>Submit payment method</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            : [
                {
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachPaymentMethod"}>Attach token</Link>,
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.iframeFields}>Create payment method form</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.txn.authkey.iframeFields}>Submit payment method</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            break;
        case 'klarna':
            paymentMethodInteraction = [
                    {
                        start: 1,
                        end: 2,
                        text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachOrderDetails"}>Attach order details</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 1,
                        end: 2,
                        text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachPaymentMethod"}>Attach Klarna provider</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 1,
                        end: 2,
                        text: <Link to={routes.api.spec + "#operation/TxnAuthkey_InitiateProvider"}>Initiate provider</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Authkey',
                        backwards: true,
                    },
                    {
                        start: 0,
                        end: 2,
                        text: <Link to={routes.api.txn.authkey.klarna}>Klarna integration</Link>,
                        includeReturn: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Payment method complete'
                    }
                ];
            break;
            case 'applepay':
                paymentMethodInteraction = [
                    {
                        start: 0,
                        end: 1,
                        text: 'Authkey',
                        backwards: true,
                    },
                    {
                        start: 0,
                        end: 1,
                        text: <HashLink to={routes.api.txn.authkey.applepay}>Create Apple Pay session</HashLink>,
                        includeReturn: true
                    },
                    {
                        start: 0,
                        end: 2,
                        text: <HashLink to={routes.api.txn.authkey.applepay + '#Specification'}> Attach Apple Pay payment token</HashLink>,
                        includeReturn: true
                    },
                    {
                        start: 0,
                        end: 1,
                        text: 'Payment method complete',
                    },
                ]
                break;            
        default:
            paymentMethodInteraction = [];
            break;
    }

    const authenticationInteraction = authentication && !is2PartyOnly && paymentMethod !== "klarna" && paymentMethod !== "applepay"
        ? [
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_SetupAuthenticationIframe"}>Setup authentication iframe</Link>,
                includeReturn: true
            },
            {
                start: 0,
                end: 1,
                text: 'Iframe details',
                backwards: true,
            },
            {
                start: 0,
                end: 2,
                text: <HashLink to={routes.api.txn.authkey.authentication}>Embed iframe</HashLink>,
                includeReturn: true
            },
            {
                start: 0,
                end: 2,
                text: 'User completes challenge',
                includeReturn: true
            },
            {
                start: 0,
                end: 1,
                text: 'Authentication complete',
            },
        ]
        : [];

    let interactions = [];

    if (is2PartyOnly) {

        interactions = [
            {
                text: "Initiate payment",
                start: 0,
                end: 1,
            },
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/Txn_Process"}>Process transaction</Link>,
                includeReturn: true,
            },
            {
                start: 0,
                end: 1,
                text: 'Receipt page',
                backwards: true,
            }];

    } else {

        interactions = [
            {
                text: "Initiate payment",
                start: 0,
                end: 1,
            },
            ...(surchargeRates && !is2PartyOnly && paymentMethod !== "applepay"
                ? [{
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + "#operation/Biller_GetPaymentRules"}>Retrieve biller surcharge rules</Link>,
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Display surcharge rates',
                    backwards: true,
                    includeReturn: true,
                }]
                : []
            ),
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_CreateAuthkey"}>Create authkey</Link>,
                includeReturn: true,
            },
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachTxnDetails"}>Attach txn details</Link>,
                includeReturn: true,
            },
            ...(fraudScreening ? [{
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachFraudScreening"}>Attach fraud screening details</Link>,
                includeReturn: true,
            }] : []),
            ...(statementDescriptor ? [{
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_AttachStatementDescriptor"}>Attach statement descriptor</Link>,
                includeReturn: true,
            }] : []),
            ...paymentMethodInteraction,
            ...(surchargeConfirmation && paymentMethod !== "applepay"
                ? [{
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + "#operation/TxnAuthkey_GetPaymentMethod"}>Lookup card type and surcharge</Link>,
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Display confirmation page',
                    backwards: true,
                    includeReturn: true,
                }]
                : []
            ),
            ...authenticationInteraction,
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TxnAuthkey_Process"}>Process transaction</Link>,
                includeReturn: true,
            },
            {
                start: 0,
                end: 1,
                text: 'Receipt page',
                backwards: true,
            },
        ];
    }

    return <Page header="Transaction flow">
        <div className="container">
            <p className="hidden-text">
                The sequence diagram demonstrates the flow for each transaction method.
            </p>
        </div>
        <Columns>
            <div>
                <h3>Payment Method</h3>
                <RadioGroup value={paymentMethod} onChange={setPaymentMethod} options={{
                    '2party': '2 Party',
                    '2party-authkey': '2 Party - AuthKey',
                    javascriptSimple: '3 Party - JavaScript Simple',
                    javascriptAdvanced: '3 Party - JavaScript Advanced',
                    iframeFields: '3 Party - Iframe Fields',
                    klarna: '3 Party - Klarna',
                    applepay: '3 Party - Apple Pay',
                }} />
            </div>
            { !is2PartyOnly && <div>
                <h3>Options</h3>
                <Checkbox label="Authentication" checked={authentication} onChange={setAuthentication} disabled={paymentMethod === "klarna" || paymentMethod === "applepay"} />
                <Checkbox label="Surcharging rate display" checked={surchargeRates} onChange={setSurchargeRates} disabled={paymentMethod === "applepay"} />
                <Checkbox label="Surcharge confirmation" checked={surchargeConfirmation} onChange={setSurchargeConfirmation} disabled={paymentMethod === "applepay"}/>
                <Checkbox label="Fraud screening" checked={fraudScreening} onChange={setFraudScreening} />
                <Checkbox label="Statement descriptor" checked={statementDescriptor} onChange={setStatementDescriptor} />
                <Checkbox label="With token" checked={withToken} onChange={setWithToken} disabled={paymentMethod === "klarna" || paymentMethod === "applepay"} />
            </div> }
        </Columns>

        <SequenceDiagram actors={actors} interactions={interactions} />
    </Page>
}
export default TxnAuthkeyPage;